import { useCallback, useContext } from 'react'
import { useMutation } from "@tanstack/react-query"
import { useSelector } from "react-redux"
import { startAudioCuttingFetch } from "store/middlewares/markingWords.crud"
import { markingWordsHooks } from ".."
import { MarkingWordsContext } from '../MarkingWordsContext'
import { useParams } from 'react-router-dom'

const useStartMarkingAudio = () => {
    const { setIsAudioMarkingMode } = useContext(MarkingWordsContext)

    const params = useParams()
    let assessmentID = params.assessmentID

    const isTraining = markingWordsHooks.useIsTraining()

    const { mutateAsync: updateEditAudioMode } = useMutation({
        mutationFn: startAudioCuttingFetch
    })

    const startMarkingAudio = useCallback(async () => {
        await updateEditAudioMode({ id: assessmentID, isTrainingAssessment: isTraining })
        setIsAudioMarkingMode(true)
    }, [assessmentID])

    return startMarkingAudio

}

export default useStartMarkingAudio